import { cn } from "@lib/cn"
import * as m from "@paraglide/messages"
import type { ContactFormData } from "@site-types/send-mail"
import type { TextareaHTMLAttributes } from "react"
import type { FieldErrors, Path, RegisterOptions, UseFormRegister } from "react-hook-form"
import { FieldTooltip } from "../FieldTooltip"
import { extractErrorMessage, fieldError } from "../field-utils"
import { useSendMailLang } from "../lang-context"

type TextAreaProps = {
  inputLabel: string
  toolTip: boolean
  inputProps: TextareaHTMLAttributes<HTMLTextAreaElement> & { name: Path<ContactFormData> }
  errorMessage: string
  register?: UseFormRegister<ContactFormData>
  errors?: FieldErrors<ContactFormData>
  rules?: RegisterOptions<ContactFormData>
}

export const TextArea = ({
  inputLabel,
  toolTip,
  inputProps,
  errorMessage,
  register,
  errors,
  rules,
}: TextAreaProps) => {
  const lang = useSendMailLang()
  const name = inputProps.name
  const id = inputProps.id || name
  const error = fieldError(errors, name)
  const errorMsg = extractErrorMessage(errors, name, errorMessage)

  return (
    <div className="mb-8 flex flex-col border-[#ffffff30] border-t-2">
      <label
        className="py-4"
        htmlFor={id}
      >
        {inputLabel}
      </label>

      <div className="relative inline-block w-full">
        <FieldTooltip
          message={errorMsg}
          open={!!error && toolTip}
        >
          <textarea
            className={cn(
              "h-[118px] w-full",
              error && "outline-2 outline-[var(--pink)]",
              inputProps.className
            )}
            {...inputProps}
            id={id}
            {...(register ? register(name, rules) : {})}
          />
        </FieldTooltip>

        <small className="block py-2 text-[11px]">
          {m.contact_formMessage_textLimit({}, { locale: lang })}
        </small>
      </div>
    </div>
  )
}
